export default function PandemicPlanProcedureDirective() {
  return {
    template: require('./pandemic-plan-procedure.html'),
    scope: {
      assessmentId: '=',
      procedure: '=',
    },
    controller: 'PandemicPlanProcedureController',
    controllerAs: 'pandemicPlanProcedureVM',
    bindToController: true,
    replace: true,
  };
}
